import { useAppSelector } from "../../redux/store/hooks"
import { selectProfessionalUser } from "../../redux/ProfessionalAuthentication"
import expect from "../../util/expect"
import Card from "../Card"
import SmallHeadingComponent from "../SmallHeadingComponent"
import { LinkStyle } from "../Link"
import {
    hidePatientSelectionViewOTP,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../../redux/Onboarding"

function OneTimePasswortInfo() {
    const user = expect(useAppSelector(selectProfessionalUser))

    const step = useAppSelector(selectOnboardingStep)
    const running = useAppSelector(selectOnboardingIsRunningState)

    return (
        <Card
            fill={true}
            width={"100%"}
            blur={hidePatientSelectionViewOTP(running, step)}>
            <div className={"flex flex-col space-y-4"}>
                <SmallHeadingComponent>Verbindungs-Passwort</SmallHeadingComponent>
                <div className={"tracking-wide"}>
                    Um auf die Daten Ihrer Patient:innen zugreifen zu können
                    müssen Sie sich zuerst mit diesen über PokalConnect
                    verbinden. Geben Sie Ihren Patient:innen dazu Ihr
                    Einmal-Passwort weiter. Das Einmal-Passwort lautet wie
                    folgt.
                </div>
                <div className={"flex items-end space-x-2"}>
                    <div
                        className={
                            "text-3xl font-bold text-primary-600 tracking-widest"
                        }>
                        {user.otp}
                    </div>
                    <div
                        onClick={() => navigator.clipboard.writeText(user.otp)}
                        className={LinkStyle}>
                        (Kopieren)
                    </div>
                </div>
            </div>
        </Card>
    )
}

export default OneTimePasswortInfo
